import React, { useContext } from 'react';

import { SkeletonLoader, TabletScreen, MobileScreen, StaticContext } from '@sm/webassets';
import { getClientEnvironmentDetails } from '@sm/utils';

const AppsGridSkeleton = props => {
  const { userAgent } = useContext(StaticContext);
  const { isDesktop } = getClientEnvironmentDetails(userAgent);
  return (
    <>
      <TabletScreen defaultMatches={isDesktop}>
        <SkeletonLoader height={230} width={700} {...props}>
          <rect x="85" y="20" rx="0" ry="0" width="50" height="50" />
          <rect x="70" y="80" rx="0" ry="0" width="80" height="10" />
          <rect x="60" y="100" rx="0" ry="0" width="100" height="10" />

          <rect x="325" y="20" rx="0" ry="0" width="50" height="50" />
          <rect x="310" y="80" rx="0" ry="0" width="80" height="10" />
          <rect x="300" y="100" rx="0" ry="0" width="100" height="10" />

          <rect x="565" y="20" rx="0" ry="0" width="50" height="50" />
          <rect x="550" y="80" rx="0" ry="0" width="80" height="10" />
          <rect x="540" y="100" rx="0" ry="0" width="100" height="10" />

          <rect x="85" y="140" rx="0" ry="0" width="50" height="50" />
          <rect x="70" y="200" rx="0" ry="0" width="80" height="10" />
          <rect x="60" y="220" rx="0" ry="0" width="100" height="10" />

          <rect x="325" y="140" rx="0" ry="0" width="50" height="50" />
          <rect x="310" y="200" rx="0" ry="0" width="80" height="10" />
          <rect x="300" y="220" rx="0" ry="0" width="100" height="10" />

          <rect x="565" y="140" rx="0" ry="0" width="50" height="50" />
          <rect x="550" y="200" rx="0" ry="0" width="80" height="10" />
          <rect x="540" y="220" rx="0" ry="0" width="100" height="10" />
        </SkeletonLoader>
      </TabletScreen>

      <MobileScreen defaultMatches={!isDesktop}>
        <SkeletonLoader height={140} width={320} className="wds-display--md-none" {...props}>
          <rect x="125" y="20" rx="0" ry="0" width="80" height="80" />
          <rect x="110" y="110" rx="0" ry="0" width="110" height="10" />
          <rect x="100" y="130" rx="0" ry="0" width="130" height="10" />
        </SkeletonLoader>
      </MobileScreen>
    </>
  );
};

export default AppsGridSkeleton;
